'use client';

import * as React from 'react';
import {
	Portal,
	Spinner,
	Stack,
	Toast,
	Toaster as ChakraToaster,
	createToaster,
} from '@chakra-ui/react';

export const toaster = createToaster({
	placement: 'bottom-end',
	pauseOnPageIdle: true,
});

export const Toaster = () => (
	<Portal>
		<ChakraToaster toaster={toaster} insetInline={{mdDown: '4'}}>
			{(toast: any) => (
				<Toast.Root width={{md: 'sm'}}>
					{toast.type === 'loading' ? (
						<Spinner size='sm' color='blue.solid' />
					) : (
						<Toast.Indicator />
					)}
					<Stack gap='1' flex='1' maxWidth='100%'>
						{toast.title && <Toast.Title>{toast.title}</Toast.Title>}
						{toast.description && (
							<Toast.Description>{toast.description}</Toast.Description>
						)}
					</Stack>
					{toast.closable && <Toast.CloseTrigger />}
				</Toast.Root>
			)}
		</ChakraToaster>
	</Portal>
);
